<div class="profile-overview" style="cursor: pointer;">


  <h1 class="profile-overview__title">

    Profile Overview

  </h1>


  <p class="profile-overview__intro">

    These sign-in details apply to your account.

  </p>


  <div

    class="profile-overview__row"

    *ngFor="let section of sections">


    <div class="profile-overview__row-label">

      {{ section.label | uppercase }}

    </div>


    <div class="profile-overview__row-value">

      {{ section.value }}

    </div>


    <!-- <div class="profile-overview__row-action">

      {{ section.action }}

    </div> -->

    <div class="profile-overview__row-action">


  <a

    *ngIf="section.id === 'username'"

    (click)="changeUsername()">

    {{ section.action }}

  </a>


  <a

    *ngIf="section.id === 'password'"

    (click)="changePassword()">

    {{ section.action }}

  </a>


  <a

    *ngIf="section.id === 'recovery-number'"

    (click)="changeRecoveryNumber()">

    {{ section.action }}

  </a>


  <a

    *ngIf="section.id === 'mfa'"

    (click)="changeMfa()">

    {{ section.action }}

  </a>


  <a

    *ngIf="section.id === 'passkeys'"

    (click)="changePasskeys()">

    {{ section.action }}

  </a>


</div>
 


  </div>


</div>